// extracted by mini-css-extract-plugin
export var isHero = "SnapSlider-module--isHero--eee79";
export var item = "SnapSlider-module--item--4853f";
export var itemContainer = "SnapSlider-module--itemContainer--82f5d";